import validUrl from "valid-url";

import { GenericObject } from "../../../types/generic.types";
import { UserRole } from "../../../types/user.types";
import {
  academyDocRef,
  adminRef,
  brandDocRef,
  coachDocRef,
  gymDocRef,
  sportClubDocRef,
  entertainmentDocRef,
} from "../../../utils/referencies";

export const isReceiver = (message: GenericObject, userId: string): boolean => {
  return message.senderRef ? message.senderRef.id !== userId : message.senderRef === null;
};

export const parseTextWithUrl = (text: string) => {
  const regex = /(http|ftp|https):\/\/([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%&:\/~+#-]*[\w@?^=%&\/~+#-])/gm;
  const refinedText = text.replace(regex, (foundText) => ` ${foundText} `);
  const splitText = refinedText.split(" ");

  return splitText.map((segment: string) => {
    return {
      text: segment,
      isUrl: !!validUrl.isWebUri(segment),
    };
  });
};

export const getCurrentUserRef = (role: UserRole, userId: string) => {
  switch (role) {
    case UserRole.sportClub:
      return sportClubDocRef(userId);
    case UserRole.store:
      return brandDocRef(userId);
    case UserRole.gym:
      return gymDocRef(userId);
    case UserRole.academy:
      return academyDocRef(userId);
    case UserRole.coach:
      return coachDocRef(userId);
    case UserRole.entertainment:
      return entertainmentDocRef(userId);
    default:
      return adminRef(userId);
  }
};

export const canSeeChat = (role: UserRole, agentType?: GenericObject) => {
  return agentType
    ? agentType.isWeb &&
        (role === UserRole.sportClub ||
          role === UserRole.admin ||
          role === UserRole.store ||
          role === UserRole.gym ||
          role === UserRole.academy ||
          role === UserRole.coach ||
          role === UserRole.entertainment)
    : role === UserRole.sportClub ||
        role === UserRole.admin ||
        role === UserRole.store ||
        role === UserRole.gym ||
        role === UserRole.academy ||
        role === UserRole.coach ||
        role === UserRole.entertainment;
};

export enum brandStatus {
  semiDisabled = "semiDisabled",
}
